import React, { useState } from 'react';
import Facebook from '@material-ui/icons/Facebook';
import Instagram from '@material-ui/icons/Instagram';
import LinkedIn from '@material-ui/icons/LinkedIn';
import TermsModal from '../Modals/TermsModal';

const Footer = () => {
  let [OpenTermsModel, setOpenTermsModel] = useState(false);
  const showTermsModel = () => {
    setOpenTermsModel(!OpenTermsModel);
  };
  return (
    <div className='footer-bg '>
      <div className=''>
        <div className=' md:w-full '>
          <p className=' text-center text-white  text-sm md:text-md w-full pb-3 pt-8 md:pt-8'>
            تابعنا على مواقع التواصل الاجتماعي
          </p>
          <div className=' flex justify-center md:flex pb-4 md:pt-2 '>
            <a
              target='_blanck'
              href='https://www.facebook.com/%D9%86%D8%A8%D9%8A%D9%84-Nabeel-101666391515679/'
              className='px-2'
            >
              <Facebook alt='facebook' style={{ color: 'white' }} />
            </a>
            <a target='_blanck' href='Https://www.instagram.com/nabeel_project'>
              <Instagram alt='instagram' style={{ color: 'white' }} />
            </a>
            <a
              target='_blanck'
              href='https://www.linkedin.com/company/nabeel-project/'
              className='px-2'
            >
              <LinkedIn alt='instagram' style={{ color: 'white' }} />
            </a>
          </div>
        </div>
        <div className='md:flex md:justify-center text-center  '>
          <button
            type='submit'
            className='border text-white rounded-lg p-2 w-40 h-8 text-sm text-center focus:outline-none mb-8 mx-3'
            onClick={showTermsModel}
          >
            سياسة الأستخدام
          </button>
          <button
            type='submit'
            className='border text-white rounded-lg p-2 w-40 h-8 text-center text-sm focus:outline-none mb-8 mx-3'
            onClick={showTermsModel}
          >
            شروط الخدمة
          </button>
        </div>
      </div>

      <div>
        <p className='text-white text-center md:text-md text-sm  md:pt pb-3'>
          ©2020 NABEEL TEAM
        </p>
      </div>
      <TermsModal
        OpenTermsModel={OpenTermsModel}
        showTermsModel={showTermsModel}
      />
    </div>
  );
};

export default Footer;
